import React, { Component } from 'react'
import GlobalValues from '../lib/values'
let runOnce

class App extends Component {
  render () {
    if (!runOnce) {
      runOnce = true
      GlobalValues.fetchGlobalSettings()
    }

    return (
      <div className="rootWindow">
        {this.props.children}
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/app.js